import { signInAction } from '@onhandtech/onhand-fe-shared/lib/firebase'
import type { PayloadAction } from '@reduxjs/toolkit'
import { ONHAND_EMAIL_DOMAIN } from 'constants/staff'
import { setIsStaffUser } from 'redux/authentication/actions'
import type { SagaIterator } from 'redux-saga'
import { put } from 'redux-saga/effects'

import type { SignInPayload } from '../firebase.types'

export function* beingSignInSaga(action: PayloadAction<SignInPayload>): SagaIterator {
  const { email, password } = action.payload

  const isStaffEmail = email.includes(ONHAND_EMAIL_DOMAIN)
  yield put(setIsStaffUser(isStaffEmail))

  if (isStaffEmail) {
    yield put(signInAction(email, password))
  }
}
